<!-- TODO Fix everything -->
<!-- <div *ngIf="viewMode !== 'mobile'" class="sidenav-container create-notification-sidenav"> -->
  <owc-side-menu mode="side" opened class="sidenav" autoFocus="false">
    <owc-list no-border>
      <div>

        <owc-list-item>

          <div (click)="updatePrevNextBtnState(true,false,'notificationTitle', '/create-notification/notification-title')" style="margin-left: 15px; cursor: pointer;">

            Notification Title

          </div>

        </owc-list-item>

        <owc-list-item>
          <div (click)="updatePrevNextBtnState(false,false, 'notificationDoc', '/create-notification/notification-doc')" 
               style="margin-left: 15px; cursor: pointer;"
               [ngClass]=" isNotiDoc ? 'required-field': '' ">
            Notification document
          </div>
        </owc-list-item>
        <owc-list-item>
          <div (click)="updatePrevNextBtnState(false,false, 'recipients', '/create-notification/recipients')" 
               style="margin-left: 15px; cursor: pointer;" 
               [ngClass]=" isRecepient ? 'required-field': '' ">
            Recipients
          </div>
        </owc-list-item>
        <owc-list-item>
          <div (click)="updatePrevNextBtnState(false,false, 'messageAttachment', '/create-notification/message-attachment')" 
               style="margin-left: 15px; cursor: pointer;" 
               [ngClass]=" isMess_Att ? 'required-field': '' ">
            Message and attachments
          </div>
        </owc-list-item>
        <owc-list-item>
          <div (click)="updatePrevNextBtnState(false,false, 'configureFeedback', '/create-notification/configure-feedback')" 
               style="margin-left: 15px; cursor: pointer;">
            Configure feedback form
          </div>
        </owc-list-item>
        <owc-list-item>
          <div (click)="updatePrevNextBtnState(false,false, 'dueDateReminder', '/create-notification/due-date-reminder')" 
               style="margin-left: 15px; cursor: pointer;"
               [ngClass]=" isDue_Rem ? 'required-field': '' ">
            Due date and reminder
          </div>
        </owc-list-item>
        <owc-list-item>
          <div (click)="updatePrevNextBtnState(false,true, 'dailySummaryReport', '/create-notification/daily-summary-report')" 
               style="margin-left: 15px; cursor: pointer;"
               [ngClass]=" isDailyReport ? 'required-field': '' ">
          Daily Summary Report
          </div>
        </owc-list-item>
      </div>
    </owc-list>
  </owc-side-menu>
     <owc-modal-dialog size="medium" [(ngModel)]="visible">
        <dl-custom-confirmation-dialog [data]="inputData" (closeDialog)="onDialogClose($event)"></dl-custom-confirmation-dialog>
      </owc-modal-dialog>

      <!-- Confirmation Dialog for unsaved feedback -->
      <owc-modal-dialog size="small" [(ngModel)]="confirmationDialogVisible">
        <owc-component-header slot="header">Warning</owc-component-header>
        <div>
          <owc-typography variant="body2">
            You have changes not applied in the feedback form controls. Please apply them to continue.
          </owc-typography>
        </div>
        <owc-component-footer slot="footer">
          <owc-button (click)="onConfirmationDialogClose()">Accept</owc-button>
        </owc-component-footer>
      </owc-modal-dialog>
<!-- </div> -->
<div class="desktop-sidenav-content">
  <ng-content select="[sidecontent]"></ng-content>
</div>